module.exports = __webpack_public_path__ + "img/5-5.f566fc27.svg";